import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  actionText: {
    fontSize: '16px !important',
  },
}))
